const initialState = {};

export default function globalErrorReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_ERROR":
      return {
        name: action.payload.name,
        message: action.payload.message,
        stack: action.payload.stack
      };
    case "CLEAR_ERROR":
      return {};
    default:
      return state;
  }
}
